<template>
  <b-table
    :items="items"
    :fields="fields"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    striped
    no-local-sorting
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
        <b-dropdown-item @click="editarHistorico(item.item)" v-if="podeEditar">
          {{ $t('GERAL.EDITAR') }}
        </b-dropdown-item>
        <b-dropdown-item
          @click="confirmarExclusao(item.item)"
          v-if="podeExcluir"
        >
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import Permissoes from '@/components/mixins/permissoes';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import HistoricoLancamentoService from '@/common/services/historico-lancamento/historico-lancamento.service.js';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: 'descricao',
          label: 'Documento',
          sortable: true,
        },
        {
          key: 'tipoHistorico',
          label: 'Tipo histórico',
          sortable: true,
        },
        {
          key: 'tipoFluxoFinanceiro',
          label: 'Tipo Fluxo Financeiro',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
    };
  },
  methods: {
    editarHistorico(item) {
      this.$emit('editar-historico', item);
    },
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('GERAL.CONFIRMAR_EXCLUSAO'),
        this.$t('GERAL.CONFIRMAR_EXCLUSAO_ITEM').formatUnicorn({
          item: `${item.descricao}`,
        })
      );
      respostaExclusao.isConfirmed ? this.excluir(item.id) : {};
    },
    excluir(id) {
      this.$store.dispatch(START_LOADING);
      HistoricoLancamentoService.excluir(id)
        .then(() => {
          this.$emit('atualizar-tabela');
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('GERAL.ITEM_DELETADO').formatUnicorn({
              item: this.$t('FINANCEIRO.HISTORICO_LANCAMENTO'),
            })
          );
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
